module.exports = __webpack_public_path__ + "img/苍术.551fff82.jpg";